/**
 * Created by dev on 2020/11/11.
 */
import gob from '../gob.js'
let ruler={
  rules:{
    requireVaild:function(value){
      var val=value+'';
      if(!val) return false;
      if(val.length<=0) return false;
      return true;
    },
    integer:function(value){
      var val=value+'';
      var reg=/^[-+]?\d*$/;
      if(!reg.test(val)){
        return false;
      }else{
        return true;
      }
    },
    number:function(value){//正浮点数+0
      var val=value+'';
      var reg=/^\d+(\.\d+)?$/
      if(!reg.test(val)){
        return false;
      }else{
        return true;
      }
    },
    isFloat2:function(value){
      var val=value+'';

    },
    isCN:function(value){
      var val=value+'';
      if(!(/^[\u0391-\uFFE5]+$/).test(val)) return false;
      return true;
    },
    idCard:function(value){
      var val=value+'';
      var regIdCard=/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      //如果通过该验证，说明身份证格式正确，但准确性还需计算
      if(regIdCard.test(val)){
        if(val.length==18){
          var idCardWi=new Array( 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ); //将前17位加权因子保存在数组里
          var idCardY=new Array( 1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2 ); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
          var idCardWiSum=0; //用来保存前17位各自乖以加权因子后的总和
          for(var i=0;i<17;i++){
            idCardWiSum+=val.substring(i,i+1)*idCardWi[i];
          }
          var idCardMod=idCardWiSum%11;//计算出校验码所在数组的位置
          var idCardLast=val.substring(17);//得到最后一位身份证号码
          //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
          if(idCardMod==2){
            if(idCardLast=="X"||idCardLast=="x"){
              return true;
            }else{
              return false;
            }
          }else{
            //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
            if(idCardLast==idCardY[idCardMod]){
              return true;
            }else{
              return false;
            }
          }
        }
      }else{
        return false;
      }
    },
    mobile:function(value){
      var val=value+'';
      if(val.length!=11) return false;
      const reg = new RegExp(/^1(3|4|5|7|8)\d{9}/g)
      const result = val.match(reg)
      if (!result) {
        return false;
      } else {
        return true;
      }
    },
    email:function(value){
      var val=value+'';
      var reg=/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if(!reg.test(val)){
        return false;
      }else{
        return true;
      }
    }
  },
  handleVaild(rules){
    var vaildRes={};
    for(var key in rules){
      vaildRes=rules[key].vaild(key);
      if(!vaildRes.flag) break;
    }
    if(!(vaildRes.flag)){
      if(!(vaildRes.tip)){
        gob.changeStore('AppTopTip', {onOff: true, text: '信息填写不完整！请检查必填项'})
      }else{
        gob.changeStore('AppTopTip', {onOff: true, text: vaildRes.tip})
      }
    }
    return vaildRes.flag;
  }
}
export default ruler



// WEBPACK FOOTER //
// ./src/utils/ruler.js